import React from 'react'
import SearchForm from 'component/Home/SearchForm'
import HotelSearchWrapper from './hotelSearchArea'
import { useHotelContext } from 'hooks/hotel/useHotelContext'
import { Navigate } from 'react-router-dom'

const HotelSearchArea = () => {

  const { hotelSearchParams , availabiltyResults } = useHotelContext() 

  if (
    !hotelSearchParams?.destination &&
    !hotelSearchParams?.checkInDate &&
    !hotelSearchParams?.checkOutDate &&
    !availabiltyResults
) {
    return <Navigate to="/?tab=hotel" />;
}
  return (
    <>
      <SearchForm/>
      <HotelSearchWrapper/>
    </>
  )
}

export default HotelSearchArea